import { CaretDownIcon, CaretRightIcon } from 'components/icons';
import React from 'react';
import activateimage from 'assets/images/activate.png';
import { useHistory } from 'react-router';
import FirebaseAnalytics, { AnalyticsLogStatus } from 'libs/analytics';
import { getDeviceType } from 'libs';
import styles from './activate-card.module.scss';

export default function ActivateCard({
  accountChecker: { completedStages, totalStages, completed },
  ownerType,
}) {
  const history = useHistory();
  const gotoOnboarding = () => {
    FirebaseAnalytics.logWithValue('activate_business', {
      STATUS: AnalyticsLogStatus.SUCCESS,
      DEVICE_TYPE: getDeviceType(),
    });
    history.push({
      pathname: '/onboarding',
      state: {
        accountChecker: { completedStages, totalStages, completed },
      },
    });
  };
  return (
    <div className={styles.activatecard} id="activateCard">
      <div className={styles.left}>
        <div className={styles.titleGroup}>
          <CaretDownIcon />
          <h3 className={styles.title}>Ready for Business 🎉</h3>
        </div>
        <p className={styles.text}>
          Before customers can pay you, you’ll need to activate your business.
          You’re are almost setup. {completedStages} out of {totalStages}{' '}
          completed already.
        </p>
        {ownerType === 'OWNER' && (
          <button
            className={styles.activatebutton}
            onClick={gotoOnboarding}
            type="button"
          >
            <span>Activate your Business</span>
            <CaretRightIcon fill="#232340" />
          </button>
        )}
      </div>
      <div className="right">
        <img src={activateimage} alt="activate image" />
      </div>
    </div>
  );
}
